<template>
	<!-- 选择合作达人 -->
	<div>
		<el-drawer
			title="选择合作达人"
			size="724px"
			:append-to-body="true"
			:visible.sync="visible"
			@closed="reset"
			:wrapperClosable="false"
		>
			<div class="drawer-content">
				<div class="drawer-content-title fz-16 mb-24 mt-4">选择达人</div>
				<!-- 搜索框部分 -->
				<div class="flex flex-align-center">
					<SelectTag
						ref="selectTag"
						:type="1"
						:placeholder="'请选择达人标签'"
						style="width: 200px; flex-shrink: 0"
						:collapseTags="true"
						:multiple="true"
						v-model="tag_id"
					></SelectTag>
					<div class="flex flex-align-center search-content ml-12">
						<div
							@mouseover="borderColor = '#2475ff'"
							@mouseleave="mouseleave"
							class="select-search-content flex flex-align-center"
							:style="{ borderColor: borderColor }"
						>
							<el-select
								@change="onChange"
								v-model="selectType"
								@visible-change="visibleChange"
								:popper-append-to-body="false"
								popper-class="dropdown"
								class="select-content"
							>
								<el-option
									v-for="(item, index) in optionsList"
									:value="item.value"
									:label="item.label"
									:key="index"
								></el-option>
							</el-select>
							<div class="line"></div>
							<el-input
								clearable
								class="search-input"
								:placeholder="placeholderText"
								v-model="anchorOrAccount"
							></el-input>
						</div>
						<el-button class="searchBtn" @click="getDrList()">搜索</el-button>
					</div>
				</div>
				<!-- 新增达人提示按钮部分 -->
				<div class="mt-12 flex-just-end flex-row">
					<el-button
						@click="skipCRM"
						type="text"
						class="yx-pingfang-semibold font-h5-regular"
					>没找到?去达人CRM添加</el-button>
				</div>
				<!-- 列表部分 -->
				<div class="mt-24 mb-40 drList-content" v-loading="loading">
					<div v-if="drList.length" class="anthor-table">
						<div class="anthor-table-header">
							<div class="anthor-table-tr">
								<div class="anthor-table-td head-color" style="width: 28px">
									<el-checkbox class="el-check-box" label v-model="checkAll" :indeterminate="indeterminate"></el-checkbox>
								</div>
								<div
									class="anthor-table-td yx-color-text-p-4 fz-14 text-align-left pl-6"
									style="width: 290px"
								>达人昵称</div>
								<div
									class="anthor-table-td yx-color-text-p-4 fz-14 text-align-left"
									style="width: 300px; padding-left: 10px"
								>{{ platformId | formatPlatformName('unify') }}</div>
								<div
									class="anthor-table-td yx-color-text-p-4 fz-14 text-align-left"
									style="width: 100px"
								>粉丝数</div>
							</div>
						</div>
						<div
							class="anthor-table-body"
							v-scroll-lazy-load="{
								loadData,
								distance: 300,
								delay: 1000,
								callback: fn => this.$once('hook:beforeDestroy', () => fn()),
							}"
						>
							<el-checkbox-group v-model="selectArr">
								<div class="anthor-table-tr" v-for="row in drList" :key="row.id">
									<div class="anthor-table-td" style="width: 30px">
										<el-checkbox
											:label="row.id"
											:disabled="disabledList.some(item => item.id === row.id) || ($isSp(row.platform_id) && row.check_status != 2)"
										></el-checkbox>
									</div>
									<div
										class="anthor-table-td text-align-left pl-6"
										style="width: 290px"
									>{{ row.anchor_name }}</div>
									<div class="anthor-table-td text-align-left pl-24 flex-row" style="width: 300px">
										<SpVerify
											:anchoId="row.id"
											:anchorUid="row.anchor_uid"
											:platformId="row.platform_id"
											:type="row.check_status"
											@refresh="spVerifyRefresh"
										>
											<span class="mr-4">{{ anchorAccount(row) }}</span>
										</SpVerify>
									</div>
									<div class="anthor-table-td text-align-left" style="width: 92px">{{ row.fans_num }}</div>
								</div>
							</el-checkbox-group>
							<p class="pt-20 pb-20 font-h4-regular yx-color-text-regular flex-center">
								<i class="el-icon-loading fz-16 mr-4" v-if="loadmore.status === 'loading'"></i>
								<span :class="loadmore.status === 'nomore' ? 'nomore' : ''">{{ loadmore.text }}</span>
							</p>
						</div>
					</div>
					<div v-if="!drList.length && !loading" class="empty-content">
						<img class="empty-search" src="@/assets/public/empty-search@2x.png" alt />
						<div class="fz-14 yx-color-text-secondary">搜索无结果</div>
					</div>
				</div>
				<!-- 底部按钮部分 -->
				<div class="bott">
					<span class="pl-24 font-h5-regular yx-color-text-primary">
						已选
						<span class="yx-color-primary">{{ selectedNum }}</span>
						个，最多可选
						<span class="yx-color-primary">{{ limit }}</span>
						个
					</span>
					<div class="mr-16">
						<el-button @click="handleClose">取 消</el-button>
						<el-button type="primary" @click="submit" :loading="btnloading" :disabled="btnIsAbled">确认添加</el-button>
					</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { selectListPage } from '@/api/shopManage';
import SelectTag from '@/components/business/tagDialog/selectTag.vue';
export default {
	name: 'ChooseCooAnthorDrawer',
	components: { SelectTag },
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_ALL.value,
		},
		selectable: {
			type: Function,
			default: () => {
				return () => {};
			},
		},
	},
	data() {
		return {
			visible: false,
			tag_id: '', //Select框绑定的达人标签的值
			anchorOrAccount: '', //input框绑定的达人名称/抖快号的值
			options: { selectable: true },
			selectArr: [], // 选择的达人id列表
			selectObjArr: [], // 选择的达人对象列表
			disabledList: [], //已经禁用的列表
			drList: [], //所有达人的列表
			limit: 20,
			loading: true,
			btnloading: false,
			btnIsAbled: true,

			params: {
				page_index: 1,
				page_size: 20,
			},
			loadmore: {
				text: '上拉加载更多',
				status: 'pending',
			},
			checkAll: false,
			indeterminate: false,
			borderColor: '#e2e3e8',
			visibleStyle: false,
			selectType: 'anchor_name',
			placeholderText: '请输入达人昵称',
		};
	},
	watch: {
		anchor_account(val) {
			if (!val) this.getDrList();
		},
		selectedNum(val) {
			this.btnIsAbled = val > 20 || this.selectArr.length == 0;
		},
		checkAll(val) {
			this.selectArr = val ? this.notSelectedDrList.map(item => item.id) : [];
		},
		list: {
			handler(val) {
				this.indeterminate = !!(val.selectArr.length && val.drList.length && val.selectArr.length !== val.drList.length);
			},
			deep: true,
		},
		selectArr(val, pre) {
			// console.log(val, pre);
			// 新增
			if (val.length > pre.length) {
				// 找出新增的达人ID
				const addedIdArr = val.filter(item => !pre.includes(item));
				// 匹配当前的达人列表找出新增的达人对象
				const addedObjArr = this.drList.filter(item => addedIdArr.includes(item.id));
				// 添加到选中的对象列表中
				this.selectObjArr.push(...addedObjArr);
			} else {
				// 找出新增的达人ID
				const deledIdArr = pre.filter(item => !val.includes(item));
				// 匹配当前的达人列表找出新增的达人对象
				deledIdArr.forEach(element => {
					// 匹配找出删除的达人对象
					const ind = this.selectObjArr.findIndex(item => element === item.id);
					// 在选中的对象列表中删除达人
					this.selectObjArr.splice(ind, 1);
				});
			}
			// console.log(this.selectObjArr);
		},
	},
	computed: {
		selectedNum() {
			return this.selectArr.length + this.disabledList.length;
		},
		list() {
			return {
				drList: this.drList,
				selectArr: this.selectArr,
			};
		},
		notSelectedDrList() {
			return this.drList.filter(item => {
				const exist = this.disabledList.every(disabledItem => disabledItem.id !== item.id);
				return exist;
			});
		},
		temPF() {
			let tempf = {
				[+dataMap.PLATFORM_DY.value]: '抖音号',
				[+dataMap.PLATFORM_KS.value]: '快手号',
				[+dataMap.PLATFORM_SP.value]: '视频号ID',
			};
			return tempf[+this.platformId];
		},

		optionsList({ temPF }) {
			return [
				{
					label: '达人昵称',
					value: 'anchor_name',
				},
				{
					label: temPF,
					value: 'anchor_account',
				},
			];
		},
	},
	methods: {
		spVerifyRefresh(res) {
			const index = this.drList.findIndex(item => item.id == res.anchor_id);
			this.$set(this.drList, index, {
				...this.drList[index],
				anchor_uid: res.anchor_uid,
				check_status: 2,
			});
		},
		anchorAccount(item) {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: item.anchor_account,
				[dataMap.PLATFORM_KS.value]: item.anchor_account,
				[dataMap.PLATFORM_SP.value]: item.anchor_uid,
			};
			return temPF[item.platform_id];
		},
		show(list) {
			if (list.length) {
				// 获取已合作的达人，用于在新增时禁用
				this.disabledList = list;
			}
			this.getDrList();
			this.visible = true;
		},
		loadData() {
			// 有下一页才会请求接口
			if (this.loadmore.status === 'nomore') {
				return;
			}
			this.params.page_index++;
			this.loadmore = {
				text: '加载中...',
				status: 'loading',
			};
			this.getDrList(true);
		},
		//刷新列表
		async getDrList(loadMore) {
			if (!loadMore) {
				this.params.page_index = 1;
				this.loading = true;
			}
			if (loadMore && this.loadmore.status === 'nomore') {
				return;
			}
			const data = await selectListPage({
				...this.params,
				[this.selectType]: this.anchorOrAccount,
				platform_id: this.platformId,
				tag_id: this.tag_id,
			});
			if (loadMore) {
				this.drList = this.drList.concat(data.list);
			} else {
				this.drList = data.list;
			}
			this.loadmore = !data.page.page_has ? { text: '已经到底了', status: 'nomore' } : { text: '上拉加载更多', status: 'pending' };

			if (!loadMore) {
				this.loading = false;
			}
		},
		// 保存提交
		submit() {
			const { selectObjArr } = this;
			// 转换为达人对象返回父组件
			this.$emit('getDrList', selectObjArr);
			this.$message.success('添加成功');
			this.reset();
			this.handleClose();
		},
		// 关闭
		handleClose() {
			this.visible = false;
			this.params.page_index = 1;
		},
		reset() {
			this.$refs.selectTag?.reset();
			this.anchor_account = '';
			this.selectedDrList = [];
			this.disabledList = [];
			this.params.page_index = 1;
			this.checkAll = false;
			this.selectArr = [];
			this.selectObjArr = [];
			this.indeterminate = false;
			this.drList = [];
			this.tag_id = '';
		},
		// 跳转CRM
		skipCRM() {
			const handLink = this.$router.resolve({
				path: '/talentCRM',
				query: { platformId: this.platformId },
			});
			window.open(handLink.href, '_blank');
		},
		visibleChange(val) {
			this.visibleStyle = val;
			val && (this.borderColor = '#2475ff');
			!val && (this.borderColor = '#e2e3e8');
		},
		mouseleave() {
			if (!this.visibleStyle) {
				this.borderColor = '#e2e3e8';
			}
		},
		onChange(val) {
			this.anchorOrAccount = '';
			this.placeholderText = val === 'anchor_name' ? '请输入达人昵称' : `请输入${this.temPF}`;
		},
	},
};
</script>

<style lang="less" scoped>
.drawer-content {
	border-radius: 8px;
	padding: 20px 16px 16px 16px;
	background: @color-gy1;
}
/deep/ .el-drawer__body {
	padding: 16px !important;
	background-color: #f7f8f9;
	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-thumb {
		height: 26px;
		border-radius: 3px;
		background-color: @border-color-lighter;
	}
}
.searchBtn {
	position: relative;
	left: -1px;
	width: 72px;
	background-color: @color-primary;
	color: #ffffff;
	font-size: 13px;
	border-radius: 2px;
	height: 35px;
}
.bott {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2000;
}
.select-search-content {
	width: 100%;
	border-right: none !important;
	border-radius: 4px 0px 0px 4px;
	border: 1px solid @color-gy5;
}
.select-content {
	/deep/ .el-input__inner {
		border: none !important;
	}
}
.anthor-table {
	display: table;
	&-header {
		color: @color-text-secondary !important;
		font-size: 12px !important;
		font-family: PingFangSC-Regular;
	}
	&-body {
		overflow-y: auto;
		.nomore {
			&::before {
				content: '- ';
			}
			&::after {
				content: ' -';
			}
		}
	}
	&-tr {
		display: table-row;
	}
	&-td {
		display: table-cell;
		font-size: 12px;
		padding: 12px 0;
		border-bottom: 1px solid @border-color-base;
	}
}
&::-webkit-scrollbar {
	width: 6px;
}

&::-webkit-scrollbar-thumb {
	height: 26px;
	border-radius: 3px;
	background-color: @color-text-placeholder;
}
/deep/.el-checkbox__label {
	display: none;
}
.search-content {
	width: 562px;
}
.search-input {
	/deep/ .el-input__inner {
		width: 100%;
		border-radius: 4px 0px 0px 4px;
		height: 32px;
		border: none !important;
	}
	/deep/ .el-input__inner::-webkit-input-placeholder {
		color: @color-text-placeholder !important;
		font-size: 14px;
	}
}

.anthor-table-body {
	padding: 0 16px 16px 16px;
	height: calc(100vh - 320px);
}
.anthor-table-header {
	border-radius: 4px 4px 0 0;
	padding: 0 16px 0 16px;
	background: @color-gy3;
}
.drawer-content-title {
	position: relative;
	color: @color-gy9;
	font-weight: 500;
	padding-left: 8px;
}
.drawer-content-title::after {
	content: '';
	width: 3px;
	height: 17px;
	background: @color-b4;
	border-radius: 20px;
	position: absolute;
	left: 0px;
	top: 50%;
	transform: translateY(-50%);
}
.empty-content {
	text-align: center;
	height: calc(100vh - 200px);
	.empty-search {
		margin-top: 76px;
		width: 96px;
		height: 96px;
	}
}
.visibleStyle {
	border-color: @color-primary !important;
}
.line {
	width: 1px;
	height: 20px;
	background: @color-gy5;
}
.drList-content {
	text-align: center;
	height: calc(100vh - 300px);
	overflow: hidden;
}
/deep/ .dropdown {
	border: 1px solid #f5f5f5;
}
/deep/ .el-check-box {
	.is-indeterminate .el-checkbox__inner {
		border: 1px solid transparent !important;
	}
}
/deep/ .is-disabled {
	.el-checkbox__inner {
		border: 1px solid #e2e3e8 !important;
	}
}
</style>
